import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { RaceCardMeta } from 'src/domains/sportsbook/webview/components/raceCard/raceDetails/raceCardMeta/RaceCardMeta';
import { MetaPropsType } from 'src/domains/sportsbook/webview/components/raceCard/raceDetails/raceCardMeta/types';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { WeatherTemperature } from 'src/domains/sportsbook/webview/components/raceCard/raceDetails/raceCardHeader/WeatherTemperature';
import { RaceMetaDataWrapper } from 'src/domains/sportsbook/webview/components/raceCard/raceDetails/raceCardMeta/Meta.style';

export const RaceMetaData = observer(
    'Meta',
    ({ activeFilterId, isFinishedRace, race, raceWeather, shouldShowBogForMarket }: MetaPropsType) => {
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;

        return (
            <RaceMetaDataWrapper isFinishedRace={isFinishedRace}>
                {race.tagsCountry !== undefined && configState.rasGoldCountries.includes(race.tagsCountry) ? (
                    <WeatherTemperature value={raceWeather} />
                ) : null}
                <RaceCardMeta
                    activeFilterId={activeFilterId}
                    race={race}
                    shouldShowBogForMarket={shouldShowBogForMarket}
                />
            </RaceMetaDataWrapper>
        );
    }
);
